import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class Angular2PhotoswipeService {

  constructor() { }
}
